import { ref } from '@vue/composition-api';import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Vue from 'vue';
import { mapGetters } from 'vuex';
import universityCheck from '~/mixins/universityCheck';
import universityBranding from '~/mixins/universityBranding';
import oauthStatusCheck from '~/mixins/oauthStatusCheck';
import InterviewFilters from "~/components/interviews/filters/InterviewFilters.vue";
export default Vue.extend({
  name: 'MainLayout',
  components: {
    InterviewFilters: InterviewFilters
  },
  mixins: [universityCheck, universityBranding, oauthStatusCheck],
  setup: function setup() {
    var showSidebar = ref(false);
    return {
      showSidebar: showSidebar
    };
  },
  data: function data() {
    return {
      course: null,
      workshop: null,
      mockJob: null,
      showCourseDialog: false,
      showWorkshopDialog: false,
      showMockJobDialog: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('jobs', {
    showJobFilters: 'getShowJobFilters'
  })), {}, {
    showInterviewFilters: function showInterviewFilters() {
      return this.$store.getters['interviews/getShowFilters'];
    },
    hasDismissedProfileProgressDialog: function hasDismissedProfileProgressDialog() {
      return this.$store.getters['profile/progress/getHasDismissedProfileProgressDialog'];
    },
    shouldShowProfileProgressDialog: function shouldShowProfileProgressDialog() {
      return !this.hasDismissedProfileProgressDialog && !this.userHasCompleteProfile && this.userHasVerifiedUniversities;
    },
    userHasCompleteProfile: function userHasCompleteProfile() {
      var _this$$auth$user$prof;

      return ((_this$$auth$user$prof = this.$auth.user.profile_completion_status) === null || _this$$auth$user$prof === void 0 ? void 0 : _this$$auth$user$prof.percentage) === 100;
    },
    userHasVerifiedUniversities: function userHasVerifiedUniversities() {
      return Boolean(this.verifiedUniversities.length);
    },
    verifiedUniversities: function verifiedUniversities() {
      var _this$$auth$user$univ;

      return ((_this$$auth$user$univ = this.$auth.user.universities) === null || _this$$auth$user$univ === void 0 ? void 0 : _this$$auth$user$univ.filter(function (v) {
        return Boolean(v.account.verified_at);
      })) || [];
    }
  }),
  created: function created() {
    var _this = this;

    /* @see CourseListItem component */
    this.$nuxt.$on('open-course-dialog', function (course) {
      return _this.openCourseDialog(course);
    });
    /* @see WorkshopListItem component */

    this.$nuxt.$on('open-workshop-dialog', function (workshop) {
      return _this.openWorkshopDialog(workshop);
    });
    /* @see MockInterviewJobListItem component */

    this.$nuxt.$on('open-mock-job-dialog', function (job) {
      return _this.openMockJobDialog(job);
    });
    this.$store.dispatch('workshops/showWorkshopsLink');
    this.fetchCourses();
    this.fetchWorkshops();
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    openCourseDialog: function openCourseDialog(course) {
      this.course = course;
      this.showCourseDialog = true;
    },
    openWorkshopDialog: function openWorkshopDialog(workshop) {
      this.workshop = workshop;
      this.showWorkshopDialog = true;
    },
    closeCourseDialog: function closeCourseDialog() {
      this.course = null;
      this.showCourseDialog = false;
    },
    closeWorkshopDialog: function closeWorkshopDialog() {
      this.workshop = null;
      this.showWorkshopDialog = false;
    },
    openMockJobDialog: function openMockJobDialog(job) {
      this.mockJob = job;
      this.showMockJobDialog = true;
    },
    closeMockJobDialog: function closeMockJobDialog() {
      this.mockJob = null;
      this.showMockJobDialog = false;
    },
    fetchCourses: function fetchCourses() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('courses/getCourses');

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fetchWorkshops: function fetchWorkshops() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$store.dispatch('workshops/getWorkshops');

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
});